<template>
  <!-- 活动统计 -->
  <div class="activity">
    <!-- 统计图card -->
    <Card :class="chart.id" v-for="(chart,index) in chartsList" :key="chart.id">
      <!-- 统计图标题 -->
      <div slot="title" class="card-header">
        <div class="iconfont" :class="[chart.iconfont?chart.iconfont:'']"></div>
        {{chart.title}}
        <Select
          v-model="selName"
          @on-change="selChange"
          style="width: 140px;margin-left: 10px"
          v-if="chart.deal"
        >
          <Option v-for="item in dateList" :key="item" :value="item">{{item}}</Option>
        </Select>
        <DatePicker
          v-if="chart.dateRange"
          type="daterange"
          split-panels
          :open="chart.open"
          confirm
          @on-change="dateChange"
          @on-ok="dateOk"
        >
          <!-- 时间选择 -->
          <div class="date-range" @click="openSelect(index)">
            {{chart.dateRange}}
            <Icon type="ios-arrow-down" :class="{rotateUp:chart.open}" />
          </div>
        </DatePicker>
      </div>
      <!-- 统计图 扩展功能 -->
      <div slot="extra" class="card-extra" @click="exportChart(index)">
        <div class="extra-text">
          <span class="iconfont icon-daochu"></span>
          <span>导出</span>
        </div>
      </div>
      <!-- 统计图主体图表 -->
      <div class="card-body" v-if="chart.type=='chart'">
        <div :id="chart.chartId" class="chart-wrapper"></div>
      </div>
      <!-- 自定义图表 -->
      <div class="card-body_cus" v-if="chart.type=='customize'">
        <!-- 自定义图表 grid -->
        <div class="customize-wrapper" v-for="(item,index) in chart.data" :key="item.communityId">
          <div class="customize-title" v-if="item.communityName">{{index+'. '+item.communityName}}</div>
          <div class="customize-progress" v-if="item.paramsList[0].value != -1">
            <div class="customize-progress_inner" :style="{width:item.paramsList[0].value}"></div>
          </div>
          <div class="customize-data">
            <div
              class="customize-data_item"
              v-for="(value,index) in item.paramsList"
              :key="index"
            >{{value.value==-1?value.label:value.value}}</div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
// 引入 ECharts 主模块
var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/grid");
require("echarts/lib/component/legendScroll");
require("echarts/lib/component/dataZoom");
export default {
  components: {},
  props: {
    show: Boolean
  },
  watch: {
    show() {
      // 触发一次
      if (!this.resizeOnce) {
        this.eventDeal.resize();
        this.eventDealPer.resize();
        this.resizeOnce = true;
      }
    }
  },
  data() {
    return {
      eventDeal: null, // 活动数量实例
      eventDealPer: null, //自行解决率实例
      curIndex: -1, // 操作对象的索引
      resizeOnce: false, // 第一次显示的时候会 resize 一次
      /* 三个图标的配置 */
      chartsList: [
        {
          id: "eventDeal", // 用来匹配 echart 对象 匹配选择时间调用函数
          type: "chart",
          title: "事件办理",
          iconfont: "icon-shijianbanli",
          chartId: "activityNumberChart1",
          open: false, // 打开时间选择
          dateRange: "", // 选择的时间范围
          disabled: false,
          deal: false,

          option: {
            color: ["#febd55", "#36a5f4", "#f42e2f"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "line" // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            legend: {
              left: 0,
              data: ["已完成", "未完成"]
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                name: "社区",
                data: ["社区1", "社区2", "社区3", "社区4", "社区5"],
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  rotate: 0
                }
              }
            ],
            yAxis: [
              {
                type: "value",
                name: "事件数"
              }
            ],
            dataZoom: [
              {
                type: "inside",
                xAxisIndex: [0]
              }
            ],
            series: [
              {
                name: "已完成",
                type: "bar",
                stack: "事件",
                barWidth: 30,
                data: []
              },
              {
                name: "未完成",
                type: "bar",
                stack: "事件",
                barWidth: 30,
                data: []
              }
            ]
          }
        },
        {
          id: "eventSatisfaction",
          type: "customize",
          title: "办理满意度",
          iconfont: "icon-banlimanyidu",
          data: [
            {
              communityId: -1, // 社区id
              communityName: "", // 社区name
              paramsList: [
                {
                  label: "满意度",
                  value: -1
                },
                {
                  label: "评价数",
                  value: -1
                }
              ] // 参数列表
            }
          ] // 满意度数据
        },
        {
          id: "eventEfficiency",
          type: "customize",
          title: "办理效率",
          iconfont: "icon-banlixiaoshuai",
          data: [
            {
              communityId: -1, // 社区id
              communityName: "", // 社区name
              paramsList: [
                {
                  label: "处理率",
                  value: -1
                },
                {
                  label: "平均时长",
                  value: -1
                },
                {
                  label: "事件数",
                  value: -1
                }
              ] // 参数列表
            }
          ] // 满意度数据
        },
        {
          id: "eventDealPer", // 用来匹配 echart 对象 匹配选择时间调用函数
          type: "chart",
          title: "社区自行解决率",
          iconfont: "icon-shequzihangjiejueshuai",
          chartId: "activityNumberChart2",
          open: false, // 打开时间选择
          dateRange: "", // 选择的时间范围
          disabled: true,
          deal: true,
          option: {
            color: ["#febd55", "#36a5f4", "#f42e2f"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "line" // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            legend: {
              left: 0,
              data: ["已解决"]
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                name: "社区",
                data: ["社区1", "社区2", "社区3", "社区4", "社区5"],
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  rotate: 0
                }
              }
            ],
            yAxis: [
              {
                type: "value",
                axisLabel: {
                  show: true,
                  formatter: `{value}%`
                }
              }
            ],
            dataZoom: [
              {
                type: "inside",
                xAxisIndex: [0]
              }
            ],
            series: [
              {
                name: "解决率",
                type: "bar",
                stack: "事件",
                barWidth: 30,
                data: [1, 2, 3, 4, 5],
                tooltip: {
                  trigger: "item",
                  formatter: "{a}:\n{c}%"
                },
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
                      {
                        offset: 0,
                        color: "#ffd2ba"
                      },
                      {
                        offset: 1,
                        color: "#f86a69"
                      }
                    ])
                  }
                }
              }
            ]
          }
        }
      ],
      dateList: ['今天', '昨天', '本周', '本月', '自定义'],
      selName: ''
    };
  },
  computed: {
    /* 时间返回选择器的初始时间 */
    initDate() {
      let now = Date.now();
      let beginDate = now - 7 * 24 * 60 * 60 * 1000;
      //let endDate = now + 7 * 24 * 60 * 60 * 1000;
     
      // return (
      //   this.$util.FormatDate(beginDate, "yyyy-MM-dd") +
      //   "到" +
      //   this.$util.FormatDate(endDate, "yyyy-MM-dd")
      // );
       let endDate = now;
      return (
        "2019-01-01到" +
        this.$util.FormatDate(endDate, "yyyy-MM-dd")
      );
    }
  },
  created() {
    this.getEventDeal(this.initDate.split("到")); // 默认查询初始时间
    this.getEventSatisfaction(); // 事件满意度
    this.getEventEfficiency(); // 办事效率
    this.getEventDealPer(this.initDate.split("到")); //自行解决率
  },
  mounted() {
    // 如果没有初始化 实例时 初始化
    if (!this.eventDeal) {
      this.initCharts();
    }
  },
  methods: {
    // 获取事件处理 数据
    getEventDeal(data) {
      let url = this.urlobj.eventChart;

      let [beginDate, endDate] = data; // 获取 时间段
      this.$get(url, {
        beginDate,
        endDate
      })
        .then(res => {
          if (res.isSucceed) {
            let _option = this.chartsList[0].option; // 获取当前options
            let _res = res.rows[0]; // 返回对象
            // 更新图例
            _option.legend.data = _res.legend;
            // X轴名称
            _option.xAxis[0].data = _res.xaxis;
            // _option.xAxis[0].data = new Array(20).fill(_res.xaxis[0]);
            // x 轴 name 和 数据
            _res.series.forEach((item, index) => {
              _option.series[index].name = item.name;
              _option.series[index].data = item.data;
            });

            // _option.series[0].data = new Array(20).fill(20);
            // 是否倾斜x轴名称 大于10个开始倾斜
            if (_option.xAxis[0].data.length > 10)
              _option.xAxis[0].axisLabel.rotate = -30;

            this.eventDeal.setOption(_option);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    //获取社区自行解决率
    getEventDealPer(data) {
      let url = this.urlobj.getEventDealPer;

      let [beginDate, endDate] = data; // 获取 时间段
      this.$get(url, {
        beginDate,
        endDate,
        communityId: this.$store.state.streetorcommunityid
      })
        .then(res => {
          if (res.isSucceed) {
            console.log(res);
            let _option = this.chartsList[3].option; // 获取当前options
            let _res = res.rows[0]; // 返回对象
            // // 更新图例
            // _option.legend.data = _res.legend;
            // X轴名称
            _option.xAxis[0].data = _res.xaxis;
            // _option.xAxis[0].data = new Array(20).fill(_res.xaxis[0]);
            // x 轴 name 和 数据
            _res.series.forEach((item, index) => {
              // _option.series[index].name = item.name;
              _option.series[0].data[index] = item.data[0];
            });
            console.log(_option);
            // _option.series[0].data = new Array(20).fill(20);
            // 是否倾斜x轴名称 大于10个开始倾斜
            if (_option.xAxis[0].data.length > 10)
              _option.xAxis[0].axisLabel.rotate = -30;

            this.eventDealPer.setOption(_option);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 获取 办理满意度数据
    getEventSatisfaction() {
      let url = this.urlobj.eventSatisfaction;

      this.$get(url)
        .then(res => {
          if (res.isSucceed) {
            let curData = this.chartsList[1].data;
            // 造点假数据
            // for (let i = 0; i < 20; i++) {
            //   let tmp = JSON.parse(JSON.stringify(res.rows[0]))
            //   tmp.satisfaction = tmp.satisfaction - parseInt(Math.random()*50)
            //   res.rows.push(tmp)
            // }
            // 执行排序 根据满意度
            res.rows = this._.sortBy(res.rows, item => -item.satisfaction);
            // 组织数据
            let tmp = res.rows.map(item => {
              let clone = JSON.parse(JSON.stringify(curData[0].paramsList)); // 取个模板
              clone.forEach(tmp => {
                if (tmp.label == "满意度") {
                  tmp.value = item.satisfaction + "%";
                }
                if (tmp.label == "评价数") {
                  tmp.value = item.count;
                }
              });
              return {
                communityId: item.communityId,
                communityName: item.communityName,
                paramsList: clone
              };
            });
            // 更新 列表 视图
            curData.push(...tmp);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 办事效率
    getEventEfficiency(data) {
      let url = this.urlobj.eventEfficiency;

      this.$get(url)
        .then(res => {
          if (res.isSucceed) {
            let curData = this.chartsList[2].data;
            // 造点假数据
            // for (let i = 0; i < 20; i++) {
            //   let tmp = JSON.parse(JSON.stringify(res.rows[0]))
            //   tmp.efficiency = tmp.efficiency - parseInt(Math.random()*10)
            //   res.rows.push(tmp)
            // }
            // 执行排序 根据处理率
            res.rows = this._.sortBy(res.rows, item => -item.efficiency);
            // 组织数据
            let tmp = res.rows.map(item => {
              let clone = JSON.parse(JSON.stringify(curData[0].paramsList)); // 取个模板
              clone.forEach(tmp => {
                if (tmp.label == "处理率") {
                  tmp.value = item.efficiency + "%";
                }
                if (tmp.label == "平均时长") {
                  tmp.value =
                    parseFloat(item.diffTime / 1000 / 60 / 60 / 24).toFixed(2) +
                    "天";
                }
                if (tmp.label == "事件数") {
                  tmp.value = item.count;
                }
              });
              return {
                communityId: item.communityId,
                communityName: item.communityName,
                paramsList: clone
              };
            });
            // 更新 列表 视图
            curData.push(...tmp);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    /* 初始化 charts */
    initCharts() {
      for (const chart of this.chartsList) {
        // 只初始化 类型为 chart 的图表
        if (chart.type == "chart") {
          /* 初始化echart对象 */
          let _tmp = echarts.init(document.getElementById(chart.chartId));
          /* 初始化 option */
          _tmp.setOption(chart.option);
          /* 初始化页面 echart 对象 */
          this[chart.id] = _tmp;
          /* 初始化时间初始值 */
          chart.dateRange = this.initDate;
        }
      }
    },
    /* 时间选择 */
    dateChange(timeArr) {
      /* 这个判断 由于iview 返回的数据格式问题  */
      if (timeArr[0]) {
        this.chartsList[this.curIndex].dateRange =
          timeArr[0] + "到" + timeArr[1];
      } else {
        this.chartsList[this.curIndex].dateRange = this.initDate;
      }
    },
    /* 时间选择确认 */
    dateOk() {
      let _curObj = this.chartsList[this.curIndex];
      /* 1. 关闭现在的时间选择器 */
      _curObj.open = false;
      /* 2. 确认时间范围 发送新的数据请求 */
      switch (_curObj.id) {
        case "eventDeal":
          this.getEventDeal(_curObj.dateRange.split("到"));
          break;
        case "eventDealPer":
          this.getEventDealPer(_curObj.dateRange.split("到"));
          break;
      }
    },
    selChange(value){
      console.log(this.selName)
      switch(value) {
        case '今天':
          var today = this.$util.FormatDate(new Date(), "yyyy-MM-dd")
          this.chartsList[3].dateRange = today + '到' + today
          this.getEventDealPer([today, today])
        break
        case '昨天':
          var yesterday = this.$util.FormatDate(new Date() - 3600 * 1000 * 24, "yyyy-MM-dd")
          this.chartsList[3].dateRange = yesterday + '到' + yesterday
          this.getEventDealPer([yesterday, yesterday])
        break
        case '本周': 
          var nowDay = (new Date().getDay()) == 0 ? 7 : new Date().getDay() - 1
          var weekStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - nowDay)
          weekStartDate = this.$util.FormatDate(weekStartDate.getTime(), 'yyyy-MM-dd')
          nowDay = this.$util.FormatDate(new Date(), 'yyyy-MM-dd')
          console.log(nowDay, weekStartDate)
          this.chartsList[3].dateRange = weekStartDate + '到' + nowDay
          this.getEventDealPer([weekStartDate, nowDay])
        break
        case '本月' :
          var month = new Date().getMonth() + 1
          month = month < 10?'0' + month : month
          month = new Date().getFullYear() + '-' + month + '-' + '01'
          var nowDay = this.$util.FormatDate(new Date(), 'yyyy-MM-dd')
          this.chartsList[3].dateRange = month + '到' + nowDay
          this.getEventDealPer([month, nowDay])
      }
    },
    /* 点击打开时间选择 */
    openSelect(index) {
      this.curIndex = index;
      if(index == 3 && this.selName != '自定义') {
        return
      }
      let _cur = this.chartsList[this.curIndex];
      /* 关闭页面中所有展开的非向前操作对象的时间选择器 */
      for (const chart of this.chartsList) {
        if (chart.id != _cur.id && chart.open) {
          chart.open = false;
        }
      }
      /* 操作所选择的时间选择器 */
      _cur.open = !_cur.open;
    },
    /* 导出表格 */
    exportChart(index) {
      let _curObj = this.chartsList[index];
      let data = {
        communityId: this.$store.state.streetorcommunityid
      };
      /* 2. 确认时间范围 发送新的数据请求 */
      switch (_curObj.id) {
        case "eventDeal":
          // 判断没有数据 不导出
          if (this._.isEmpty(_curObj.option.xAxis[0].data)) {
            this.$Message.info("暂无数据导出");
            return;
          }
          // let [beginDate, endDate] = _curObj.dateRange.split("到");

          data.beginDate = _curObj.dateRange.split("到")[0];
          data.endDate = _curObj.dateRange.split("到")[1];

          window.open(this.$util.concatUrl(this.urlobj.eventChartExport, data));
          break;
        case "eventSatisfaction":
          // 默认有一个数据
          if (_curObj.data.length < 2) {
            this.$Message.info("暂无数据导出");
            return;
          }

          window.open(
            this.$util.concatUrl(this.urlobj.eventSatisfactionExport, data)
          );
          break;
        case "eventEfficiency":
          // 默认有一个数据
          if (_curObj.data.length < 2) {
            this.$Message.info("暂无数据导出");
            return;
          }
          window.open(
            this.$util.concatUrl(this.urlobj.eventEfficiencyExport, data)
          );
          break;
        case "eventDealPer":
          // 判断没有数据 不导出
          if (this._.isEmpty(_curObj.option.xAxis[0].data)) {
            this.$Message.info("暂无数据导出");
            return;
          }
          // let [beginDate, endDate] = _curObj.dateRange.split("到");

          data.beginDate = _curObj.dateRange.split("到")[0];
          data.endDate = _curObj.dateRange.split("到")[1];

          window.open(
            this.$util.concatUrl(this.urlobj.exportEventDealPer, data)
          );
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.activity {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-template-areas:
    "top top"
    "left right"
    "bottom bottom";

  margin-bottom: 30px;
}
/* ### 的统计表 */
.eventDeal {
  grid-area: top;
}
/* ### 的统计表 */
.eventSatisfaction {
  grid-area: left;
}
.eventEfficiency {
  grid-area: right;
}
.eventDealPer {
  grid-area: bottom;
}
/* 活动图表开始 */
.activity .card {
  width: 100%;
  margin-bottom: 20px;
}
/* 标题 */
.card-header {
  display: flex;
  align-items: center;
  height: 24px;
  line-height: 24px;
  .iconfont {
    color: #ff7d44;
    margin-right: 10px;
    font-size: 22px;
  }
}

/* 扩展 */
.extra-text {
  font-size: 14px;
  color: #67799d;
  cursor: pointer;
}
.extra-text .icon-daochu {
  margin-right: 2px;
}
/* chart */
.chart-wrapper {
  width: 100%;
  height: 330px;
}
/* 自定义图表 */
.card-body_cus {
  height: 330px;
  overflow-y: scroll;
  // chrome
  &::-webkit-scrollbar {
    display: none;
  }
}
.customize-wrapper {
  display: flex;
  align-items: center;
  &:first-child .customize-data {
    color: #333;
  }
  margin-bottom: 25px;
}
/* 标题 */
.customize-title {
  width: 7em;
  color: #666;
  margin-right: 10px;
}
/* 进度条 */
.customize-progress {
  flex: 1;
  height: 14px;
  border-radius: 8px;
  background-color: #f1f1f1;
  .customize-progress_inner {
    height: 100%;
    border-radius: 8px;
    background-color: #ff7c44;
  }
}
/* 数据 */
.customize-data {
  display: flex;
  align-items: center;
  margin-left: auto;

  font-size: 14px;
  color: #999;
  .customize-data_item {
    width: 5em;
    text-align: center;
    margin-left: 10px;
  }
}
/* 时间范围 */
.date-range {
  cursor: pointer;
  margin-left: 20px;
  color: #999;
  .ivu-icon {
    transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  }
}
/* 箭头旋转向上 */
.rotateUp {
  transform: rotateZ(-180deg);
}
</style>

